import { env } from '@funny/env';
import { OutsideMask } from '@funny/widgets';
var mask = null;
function isIOSBiggerThanNine() {
    var iosVersion = env.ua.match(/OS [0-9]+_\d[_\d]* like Mac OS X/i);
    var tmpArr = iosVersion === null || iosVersion === void 0 ? void 0 : iosVersion[0].split(' ');
    return iosVersion && iosVersion.length > 0 && Number.parseInt((tmpArr === null || tmpArr === void 0 ? void 0 : tmpArr[1]) || '', 10) >= 9;
}
/**
 * 打开一个通用链接
 * @param url 通用链接
 * @param appType 需要打开的app类型，默认cb
 * @returns
 */
function openUniversalLink(url, appType) {
    if (!(env.browser.isIOS && isIOSBiggerThanNine())) {
        return;
    }
    if (appType === 'cb') {
        window.location.href = 'https://changbaapp.com/schema?url=' + encodeURIComponent(url);
    }
    else {
        var shareParams = /xiaochangmars:\/\//i.test(url) ? url.split('//?') : '';
        window.location.href = 'https://mars.changba.com/app/share/mars_download.html?' + shareParams[1];
    }
}
/**
 * 在端外打开App
 */
export function openApp(openParams) {
    if (openParams === void 0) { openParams = {}; }
    var targetUrl = openParams.targetUrl, downloadUrl = openParams.downloadUrl, appType = openParams.appType;
    if (!appType) {
        appType = 'cb';
    }
    if (!downloadUrl) {
        downloadUrl =
            appType === 'cb' ? 'https://changba.com/d?from=home' : 'https://mars.changba.com/download/mars_download.php';
    }
    if (!targetUrl) {
        targetUrl = appType === 'cb' ? 'changba://?ac=hottest' : 'xiaochangmars://?ac=home&index=1';
    }
    var g = +new Date();
    if (/^https?:\/\//.test(targetUrl)) {
        if (appType === 'cb') {
            targetUrl =
                'changba://?ac=webview&customurl=' + encodeURIComponent(window.btoa(targetUrl)) + '&iosUseCommonShare=1';
        }
        else {
            targetUrl = 'xiaochangmars://?ac=webview&url=' + encodeURIComponent(targetUrl);
        }
    }
    // 微博上无法打开，引导浏览器打开
    if (env.browser.isWeibo) {
        if (window.location.href.indexOf('isappinstalled=0') > 0) {
            window.location.href = downloadUrl;
            return;
        }
        if (!mask) {
            mask = new OutsideMask();
        }
        mask.show();
        return;
    }
    if (!env.browser.isAndroid) {
        openUniversalLink(targetUrl, appType);
        return;
    }
    if (env.browser.isQQorWeChat) {
        if (appType === 'mars') {
            window.location.href =
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaochang.easylive&ckey=CK1333476544870&android_scheme=' +
                    encodeURIComponent(targetUrl);
        }
        else {
            window.location.href =
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.changba&ckey=' +
                    encodeURIComponent('CK1359485898763') +
                    '&android_scheme=' +
                    encodeURIComponent(targetUrl);
        }
        return;
    }
    var ifr = document.createElement('iframe');
    ifr.src = targetUrl;
    if (window.chrome || isIOSBiggerThanNine()) {
        window.location.href = ifr.src;
    }
    else {
        ifr.style.display = 'none';
        document.body.appendChild(ifr);
    }
    // 有些浏览器不支持 iframe
    window.setTimeout(function () {
        if (env.browser.isAndroid || (!env.browser.isAndroid && (!document.webkitHidden || !document.hidden))) {
            var a = +new Date();
            if (a - g < 1550) {
                try {
                    document.body.removeChild(ifr);
                }
                catch (e) {
                    console.log(e);
                }
                if (downloadUrl && typeof downloadUrl === 'string' && downloadUrl.length > 0) {
                    window.location.href = downloadUrl;
                }
            }
        }
    }, 1500);
    setTimeout(function () {
        try {
            document.body.removeChild(ifr);
        }
        catch (e) {
            console.log(e);
        }
    }, 3000);
}
